import { List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from "@mui/material";
import React, { useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteTechnicianFromPlanned, deleteTechnicianFromUnplanned } from "../../store/actions/CustomListActions";

export default function CustomList(props) {
    const dispatch = useDispatch();
    const { isTaskUpdated } = useSelector(({ customList }) => customList);

    const RemoveTechnician = (userCode) => {
        let data = {
            taskId: props.taskId,
            userCode: userCode,
        };

        if (props.isPlannedMaintenance) {
            dispatch(deleteTechnicianFromPlanned(data));
        } else {
            dispatch(deleteTechnicianFromUnplanned(data));
        }
    };

    useEffect(() => {
        if (isTaskUpdated) {
            props.closePopup();
            window.location.reload();
        }
    }, [isTaskUpdated]);

    return (
        <div>
            <div>
                <List dense={props.dense}>
                    {props.listItems.map((element,index) => {
                        return (
                            <ListItem key={element.id} id={`${props.name}_li_${index}`}>
                                <ListItemText id={`${props.name}_lit_${index}`} value={element.userName ?? element.label} primary={element.userName ?? element.label} />
                                {props.withDelete && element.userName ? (
                                    <ListItemSecondaryAction>
                                        <IconButton
                                            disabled={props.disabled}
                                            color="secondary"
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => RemoveTechnician(element.userCode)}
                                            size="large">
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                ) : null}
                            </ListItem>
                        );
                    })}
                </List>
            </div>
        </div>
    );
}
